import { Button, Callout, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { isFutureEffectiveDate } from "../../../business-logic/billingLogic";
import { StepPage } from "../../components/StepPage";
import { useResponsive } from "../../contexts";
import { useIoContext, useStore } from "../../../contexts";
import { relationshipModel } from "../../../models";
import { selectors } from "../../../store/state-selectors";
import { COBStep, getStepName } from "../ClientOnboarding.utils";
import { useCobConfig } from "../CobConfigContext";
import PackageSelector from "./PackageSelector";
import styles from "./PackagesStep.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const {
  PackagesStepTestIds
} = getTestIds();
export default function PackagesStep(_ref) {
  var _relationship$service, _relationship$service2;
  let {
    selectedBundleID,
    onSelectBundleID,
    onClickNext,
    onClickBack
  } = _ref;
  const {
    isMobile
  } = useResponsive();
  const {
    relationship
  } = useCobConfig();
  const {
    getNow
  } = useIoContext();
  const userId = useStore(selectors.user.id);
  const isBuyer = relationshipModel.isBuyer(relationship, userId);
  const hasSignatories = relationshipModel.hasSignatories(relationship);
  return /*#__PURE__*/_jsxs(StepPage, {
    header: getStepName(COBStep.selectAPackage, relationship),
    primaryBtn: /*#__PURE__*/_jsx(Button, {
      onClick: () => onClickNext(),
      children: "Next"
    }),
    onBackBtnClick: onClickBack,
    testId: PackagesStepTestIds.Root(),
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.sectionTitle,
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "h6",
        weight: "normal",
        children: "Packages"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.onlyPrimaryCanSelectCallout,
      children: [!isBuyer && hasSignatories && /*#__PURE__*/_jsx("div", {
        className: styles.onlyPrimaryCanSelectCalloutContent,
        children: /*#__PURE__*/_jsxs(Callout, {
          testId: "select-package-disabled-callout",
          children: ["Only ", relationshipModel.buyerFullName(relationship), " can select package for this proposal"]
        })
      }), /*#__PURE__*/_jsx(PackageSelector, {
        packages: (_relationship$service = (_relationship$service2 = relationship.serviceBundles) === null || _relationship$service2 === void 0 ? void 0 : _relationship$service2.bundles) !== null && _relationship$service !== void 0 ? _relationship$service : [],
        isEffectiveDateInFuture: isFutureEffectiveDate(relationship === null || relationship === void 0 ? void 0 : relationship.effectiveDate, getNow()),
        selectedBundleID: selectedBundleID,
        isMobile: isMobile,
        onSelect: id => onSelectBundleID(id)
      })]
    })]
  });
}